import styled from 'styled-components';

export const UiMonitorSessionPage = styled.div`
	padding: 30px 32px;
`;